import { render, staticRenderFns } from "./QuizGeneral.vue?vue&type=template&id=75b28220"
import script from "./QuizGeneral.vue?vue&type=script&lang=js"
export * from "./QuizGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports